export const GET_ORDER_LOADING = "GET/ORDER/loading";
export const GET_ORDER_ERROR = "GET/ORDER/error";
export const GET_ORDER_SUCCESS = "GET/ORDER/success";

export const ADD_ORDER_LOADING = "ADD/ORDER/loading";
export const ADD_ORDER_ERROR = "ADD/ORDER/error";
export const ADD_ORDER_SUCCESS = "ADD/ORDER/success";

export const UPDATE_ORDER_LOADING = "UPDATE/ORDER/loading";
export const UPDATE_ORDER_ERROR = "UPDATE/ORDER/error";
export const UPDATE_ORDER_SUCCESS = "UPDATE/ORDER/success";

export const DELETE_ORDER_LOADING = "DELETE/ORDER/loading";
export const DELETE_ORDER_ERROR = "DELETE/ORDER/error";
export const DELETE_ORDER_SUCCESS = "DELETE/ORDER/success";
